import { render, staticRenderFns } from "./PT120ProductDetailsParts.vue?vue&type=template&id=724c68bc&scoped=true&"
import script from "./PT120ProductDetailsParts.vue?vue&type=script&lang=js&"
export * from "./PT120ProductDetailsParts.vue?vue&type=script&lang=js&"
import style0 from "./PT120ProductDetailsParts.vue?vue&type=style&index=0&id=724c68bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c68bc",
  null
  
)

export default component.exports